import CrossTabMessage from "./CrossTabMessage";
import Dictionary from "../../Dictionary";
import {Timeouts} from "~/ts/library/delay/Timeouts";
import {removeArrayElement} from "~/ts/library/ToggleArrayElement";
import Events from "~/ts/library/Events";


export default class IframeSender {
    public constructor(private iframe?: HTMLIFrameElement) {
        this.setMessageCallback("callback", (payload: any) => {
            if (this.callbacks[payload.callbackId]) {
                let resolve = this.callbacks[payload.callbackId]!;
                this.removeCallback(payload.callbackId);
                resolve(payload.responsePayload);
            }
        });
    }

    public startListen(): () => void {
        return Events.addEventListener("message", window, (e: MessageEvent) => {
            if (this.iframe) {
                if (e.source !== this.iframe.contentWindow) {
                    return;
                }
            } else if (window === window.top || window.top !== e.source) {
                return;
            }
            let message: CrossTabMessage | undefined;
            try {
                message = JSON.parse(e.data).message;
            } catch (e) {

            }

            if (message) {
                let responseCallback = (responsePayload: any) => {
                    let responseMessage = new CrossTabMessage("callback", {
                        callbackId: message.callbackId,
                        receiver: message.from,
                        responsePayload: responsePayload
                    });
                    this.send(responseMessage);
                };
                this.runAction(message, responseCallback);
            }

        });
    }

    public send<TResponse>(message: CrossTabMessage): Promise<TResponse> {
        return new Promise((resolve, reject) => {
            let win = this.iframe?.contentWindow ?? window.top;

            this.addCallback(message, resolve, reject);
            if (win) {
                win.postMessage(JSON.stringify({
                    isIframeSenderMessage: true,
                    message
                }));
            }

        });
    }

    private callbacks: Dictionary<(data: any) => void> = {};

    private removeCallback(callbackId: number) {
        delete this.callbacks[callbackId];
    }

    private addCallback(message: CrossTabMessage, resolve: (data: any) => void, reject: () => void) {
        if (message.callbackTimeout) {
            this.callbacks[message.callbackId] = resolve;
            Timeouts.set(() => {
                if (this.callbacks[message.callbackId]) {
                    this.removeCallback(message.callbackId);
                    reject();
                }
            }, message.callbackTimeout);
        }
    }

    private actions: Dictionary<((payload: any, callback: (response: any) => void) => void)[]> = {};

    public setMessageCallback(action: string, callback: (payload: any, callback: (response: any) => void) => void) {
        if (!this.actions[action]) {
            this.actions[action] = [];
        }
        if (this.actions[action].indexOf(callback) == -1) {
            this.actions[action].push(callback);
        }
    }

    public removeMessageCallback(action: string, callback: (payload: any, callback: (response: any) => void) => void) {
        let actions = this.actions[action];
        if (actions) {
            removeArrayElement(actions, callback);
        }
    }

    private runAction(message: CrossTabMessage, callback: (payload: any) => void) {
        let actions = this.actions[message.action];
        if (actions) {
            for (let i = 0; i < actions.length; i++) {
                actions[i]!(message.payload, callback);
            }
        }
    }
}